import { Modal, Fade } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import CloseIcon from 'assets/images/svg/close.svg'
import { LoginBox } from 'styleds'
import RegisterForm from './RegisterForm'
import EmailConfirm from './EmailConfirm'
import { useSensors } from 'hooks/useSensors'
import { useLocation } from 'react-router-dom'

export default function SignUp({ open = false, handleClose }: { open: boolean; handleClose: Function }) {
  const [step, setStep] = useState(1)
  const [count, setCount] = useState(60)
  const [email, setEmail] = useState('')
  const { sensorsTrack } = useSensors()
  const location = useLocation()

  const notIsSingleLoginPage = useMemo(() => {
    return !(location.pathname.indexOf('/login') > -1 || location.pathname.indexOf('/earlyaccess/task') > -1)
  }, [location.pathname])

  useEffect(() => {
    setEmail('')
    setStep(1)
    setCount(60)
  }, [open])

  return (
    <Modal open={open} closeAfterTransition>
      <Fade in={open}>
        <LoginBox>
          {notIsSingleLoginPage && (
            <img
              alt=""
              src={CloseIcon}
              onClick={() => {
                handleClose('close')
                setStep(1)
                if (step === 1) {
                  sensorsTrack('GameRegisterPopClick', {
                    module: 'close',
                    register_email: email,
                    game_source: window.sessionStorage.getItem('source'),
                  })
                } else {
                  sensorsTrack('GameRegisterVerifyPopClick', {
                    module: 'close',
                    register_email: email,
                    game_source: window.sessionStorage.getItem('source'),
                  })
                }
              }}
              className="close"
            />
          )}
          {step === 1 ? (
            <RegisterForm
              changeStep={(data: string, count?: number) => {
                if (data === 'SignIn') {
                  handleClose('Login')
                  sensorsTrack('GameRegisterPopClick', {
                    module: 'sign_in',
                    game_source: window.sessionStorage.getItem('source'),
                  })
                } else {
                  if (count) {
                    setCount(count)
                  }
                  setEmail(data)
                  setTimeout(() => {
                    setStep(2)
                  })
                }
              }}
            ></RegisterForm>
          ) : (
            <EmailConfirm email={email} count={count}></EmailConfirm>
          )}
        </LoginBox>
      </Fade>
    </Modal>
  )
}
